import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";

const ROW_TITLE_WIDTHS = ["w-56", "w-44"];

/** The agent actions list while its runs load: the card and two rows. */
export const ActionListSkeleton = () => (
  <Stack
    align="start"
    gap={0}
    className="w-full divide-y divide-line overflow-hidden rounded-lg border border-line bg-surface-raised"
  >
    {ROW_TITLE_WIDTHS.map((width) => (
      <Stack align="start" key={width} gap={2} className="w-full p-4">
        <Skeleton className={cn("h-4", width)} />
        <Skeleton className="h-3 w-full" />
        <Skeleton className="h-3 w-3/4" />
        <Stack align="start" direction="row" gap={2} className="pt-1">
          <Skeleton className="h-8 w-20 rounded-full" />
          <Skeleton className="h-8 w-16 rounded-full" />
        </Stack>
      </Stack>
    ))}
  </Stack>
);
